export const getExperimentRef = (state) => state.experiments.ref;


// WEBPACK FOOTER //
// ./src/selectors/experiments.js